import { Columns } from '../../columns'

export const KDPPerformanceColumns = [Columns.PagesRead, Columns.EstimatedRoyalties]
